<template>
  <div id="app">

    <Header></Header>
    <div class="spacer"></div>

    <Login
      :isSignedIn="user.isSignedIn"
      v-on:signed-in="signInUser">
    </Login>


    <transition name="fade" mode="out-in">
      <router-view
        :beers="beers"
        :user="user">
      </router-view>
    </transition>

    <Footer
      :user="user"
      v-on:signed-out="signOutUser">
    </Footer>

    <Navbar></Navbar>
  </div>
</template>

<script>
import axios from 'axios'

import Navbar from './components/Navbar.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Login from './components/Login.vue';

export default {
  name: 'app',
  components: {
    Navbar,
    Header,
    Footer,
    Login,
  },
  data() {
    return {
      beers: [],
      user: {
        id: 0,
        id_token: 0,
        name: '',
        drinkedBeers: [],
        isSignedIn: false,
      },
    }
  },
  mounted: function(){
    this.setAllBeers(this.setDrinkedBeers, 0);
  },
  methods: {
    signInUser: function(googleUser) {
      let token = googleUser.getAuthResponse().id_token;
      let profile = googleUser.getBasicProfile();
      this.user.name = profile.getName();
      this.user.id_token = token;

      axios.post('https://klogtkryds.dk/studenterbaren/api/checkUser', {
          id_token: token,
          name: this.user.name,
        })
        .then(res => {
          this.user.id = res.data.data.id;
          this.user.nickname = res.data.data.nickname;
          this.setBeers(res.data.data.id);

        })
        .catch(() => console.log("could not retrieve user"));
      // this.user.basicInfo = googleUser.getBasicProfile();
      this.user.isSignedIn = true;
    },
    signOutUser: function() {
      this.user.isSignedIn = false;
    },
    setBeers: function(userid){
      this.setAllBeers(this.setDrinkedBeers, userid);
    },
    setAllBeers: function(func, input){
      axios.get('https://klogtkryds.dk/studenterbaren/api/beers')
        .then(res => {
          this.beers = res.data.data
          func(input);
        })
        .catch( () => {this.beers =[{name: 'ingen internetforbindelse', price: 3, abv:1},{name: 'prøv igen senere', price: 2, abv:1}]});
    },
    setDrinkedBeers: function(userid) {
      axios.get('https://klogtkryds.dk/studenterbaren/api/drinkedBeers/'+userid)
        .then(res => {
          this.user.drinkedBeers = res.data.data;
          for(let i = 0; i < this.beers.length; i++){
            for(let j = 0; j < this.user.drinkedBeers.length; j++){
              if(this.beers[i].id == this.user.drinkedBeers[j].id){
                this.beers[i] = Object.assign(this.beers[i], this.user.drinkedBeers[j]);
              }
            }
          }
        })
        .catch( () => {console.log("error"), this.user.drinkedBeers = []});
    },
  },

}
</script>

<style>
@import './main.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--primaryColor);
}
body{
  margin: 0;
  padding: 0;

}
.spacer{
  height: 80px;
}
</style>
